module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "popup"
  }, [_c('div', {
    staticClass: "turn-the-phone"
  }, [_c('div', {
    staticClass: "turn-the-phone__circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "turn-the-phone__message"
  }, [_vm._v("Vänd telefonen för att visa listan.")]), _vm._v(" "), _c('button', {
    staticClass: "go-back",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Gå tillbaka")])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.loading,
      "text": "Hämtar boenden"
    }
  }), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.isAwaitingFilter,
      "text": "Laddar skillnader"
    }
  }), _vm._v(" "), _c('div', {
    class: {
      component: true, disabled: (_vm.loading || _vm.isAwaitingFilter)
    }
  }, [_c('h1', [_vm._v("Jämför upp till 3 boenden")]), _vm._v(" "), _c('div', {
    class: {
      disabled: (_vm.accomodations.length <= 1)
    },
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('SwitchButton', {
    attrs: {
      "icon": "compare",
      "iconscale": 2,
      "value": false,
      "sync": false,
      "labels": {
        checked: 'Visar skillnader',
        unchecked: 'Visa skillnader'
      }
    },
    on: {
      "toggle": _vm.changeValue
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("Jämför intressanta boenden. Du kan också klicka på filtret visa skillnader för att bara se det som skiljer valda boenden.")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_vm._l((_vm.accomodations), function(unit, key) {
    return _c('div', [_c('div', {
      staticClass: "image",
      style: ('background-image:url(' + (unit && unit.pool && unit.pool.image) + ')')
    }, [(_vm.fromMemory) ? _c('div', {
      staticClass: "icon-bg"
    }, [_c('button', {
      staticClass: "white small border",
      on: {
        "click": function($event) {
          return _vm.removeFavoriteLocal(key)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 2
      }
    })], 1)]) : _vm._e()]), _vm._v(" "), _c('h2', [_vm._v(_vm._s((unit.display_name || unit.description_title)))]), _vm._v(" "), _c('button', {
      staticClass: "medium",
      on: {
        "click": function($event) {
          return _vm.openInfo(unit)
        }
      }
    }, [_vm._v("Info/boka")]), _vm._v(" "), _c('button', {
      staticClass: "medium white border",
      on: {
        "click": function($event) {
          return _vm.openMap(unit)
        }
      }
    }, [_vm._v("Visa på karta "), _c('icon', {
      attrs: {
        "name": "map-blue",
        "scale": 1.7
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "fact-container"
    }, [(!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('bedrooms'))) ? _c('div', {
      class: 'fact ' + (unit.bedrooms ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "antal rum",
        "scale": 1.4
      }
    }), _vm._v("\n          Sovrum (" + _vm._s(unit.bedrooms) + "st)\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('living_area'))) ? _c('div', {
      class: 'fact ' + (unit.living_area ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "area",
        "scale": 1.4
      }
    }), _vm._v("\n          Boarea (" + _vm._s(unit.living_area) + "m2)\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('internet'))) ? _c('div', {
      class: 'fact ' + (unit.internet ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "wifi",
        "scale": 1.4
      }
    }), _vm._v("\n          Wi-Fi\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('washing_machine'))) ? _c('div', {
      class: 'fact ' + (unit.washing_machine ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "tvattmaskin-black",
        "scale": 1.4
      }
    }), _vm._v("\n          Tvättmaskin\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('terrace_balcony'))) ? _c('div', {
      class: 'fact ' + (unit.terrace_balcony ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "balkong",
        "scale": 1.4
      }
    }), _vm._v("\n          Balkong/altan\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('dishwasher'))) ? _c('div', {
      class: 'fact ' + (unit.dishwasher ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "diskmaskin-black",
        "scale": 1.4
      }
    }), _vm._v("\n          Diskmaskin\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('pets_allowed'))) ? _c('div', {
      class: 'fact ' + (unit.pets_allowed ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "husdjur-black",
        "scale": 1.4
      }
    }), _vm._v("\n          Husdjur tillåtna\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('sauna'))) ? _c('div', {
      class: 'fact ' + (unit.sauna ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "bastu-black",
        "scale": 1.4
      }
    }), _vm._v("\n          Bastu\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.settings.SettingLockTypes.active && (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('direct_incheck')))) ? _c('div', {
      class: 'fact ' + 'active'
    }, [_c('icon', {
      attrs: {
        "name": "direkt-incheck-black",
        "scale": 1.4
      }
    }), _vm._v("\n          " + _vm._s(unit.direct_incheck ? _vm.SITE_CONFIG.settings.SettingLockTypes.texts[1].title : _vm.SITE_CONFIG.settings.SettingLockTypes.texts[0].title) + "\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.settings.SettingLockTypes.active && (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('lock_type_id')))) ? _c('div', {
      class: 'fact ' + (unit.lock_type_id ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "direkt-incheck-black",
        "scale": 1.4
      }
    }), _vm._v("\n          " + _vm._s(unit.lock_type_id ? _vm.SITE_CONFIG.settings.SettingLockTypes.texts[unit.lock_type_id].title : Object.values(_vm.SITE_CONFIG.settings.SettingLockTypes.texts).map(function(item) {
      return item.title;
    }).join(' / ')) + "\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('handicap_rooms'))) ? _c('div', {
      class: 'fact ' + (unit.handicap_rooms ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "handikapp",
        "scale": 1.4
      }
    }), _vm._v("\n          Handikappanpassat\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('dryer_cabinet'))) ? _c('div', {
      class: 'fact ' + (unit.dryer_cabinet ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "torkskap",
        "scale": 1.4
      }
    }), _vm._v("\n          Torkskåp\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('toilets'))) ? _c('div', {
      class: 'fact ' + (unit.toilets ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "wc",
        "scale": 1.4
      }
    }), _vm._v("\n          WC (" + _vm._s(unit.toilets) + "st)\n        ")], 1) : _vm._e(), _vm._v(" "), ((!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('hot_tub'))) && _vm.SITE_CONFIG.site != 'branas') ? _c('div', {
      class: 'fact ' + (unit.hot_tub ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "badtunna",
        "scale": 1.4
      }
    }), _vm._v("\n          Badtunna\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('extra_beds'))) ? _c('div', {
      class: 'fact ' + (unit.extra_beds ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "sangar",
        "scale": 1.4
      }
    }), _vm._v("\n          Extrabäddar (" + _vm._s(unit.extra_beds) + "st)\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('final_cleaning_included'))) ? _c('div', {
      class: 'fact ' + (unit.final_cleaning_included ? 'active' : '')
    }, [_c('div', [_c('icon', {
      attrs: {
        "name": "stadning-black",
        "scale": 1.4
      }
    }), _vm._v("\n            Slutstäd (ingår)\n          ")], 1)]) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('final_cleaning_available'))) ? _c('div', {
      class: 'fact ' + (unit.final_cleaning_available ? 'active' : '')
    }, [_c('div', [_c('icon', {
      attrs: {
        "name": "stadning-black",
        "scale": 1.4
      }
    }), _vm._v("\n            Slutstäd (tillval)\n          ")], 1)]) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('child_friendly'))) ? _c('div', {
      class: 'fact ' + (unit.child_friendly ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "smiley-black",
        "scale": 1.4
      }
    }), _vm._v("\n          Extra barnanpassat\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('beds'))) ? _c('div', {
      class: 'fact ' + (unit.beds ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "sangar",
        "scale": 1.4
      }
    }), _vm._v("\n          Bäddar (" + _vm._s(unit.beds) + "st)\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('fireplace'))) ? _c('div', {
      class: 'fact ' + (unit.fireplace ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "kamin",
        "scale": 1.4
      }
    }), _vm._v("\n          Öppen spis\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.filters.chargeStation && (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('charging_post')))) ? _c('div', {
      class: 'fact ' + (unit.charging_post ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "laddstolpe-black",
        "scale": 1.4
      }
    }), _vm._v("\n          Laddstolpe\n        ")], 1) : _vm._e()])])
  }), _vm._v(" "), (_vm.accomodations.length < 3 && _vm.fromMemory) ? _c('div', {
    on: {
      "click": _vm.goToAccomodations
    }
  }, [_c('div', {
    staticClass: "add-icon"
  }), _vm._v(" "), _vm._m(0)]) : _vm._e()], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', {
    staticClass: "add-more"
  }, [_vm._v("Lägg till fler boenden "), _c('br'), _vm._v(" och jämför")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7802c2b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Accomodation/AccomodationsCompare.vue
// module id = 997
// module chunks = 0